import Typography from "@mui/material/Typography";

import { KeyQuestionFeedItem } from "@app/analytics/Home/types";
import ROUTES from "@app/common/routes";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import { Link } from "@rui/Link";
import Menu from "@rui/Menu";
import MenuItem from "@rui/MenuItem";
import { Bold } from "@rui/styles";

import DetailsPanelHeader from "./DetailsPanelHeader";
import DetailsPanelVideoClip from "./DetailsPanelVideoClip";
import {
  ActionsMenuButton,
  ContextAccordion,
  DetailsPanelContent,
  DetailsPanelFooter,
  Panel,
} from "./styles";

interface KeyQuestionDetailsPanelProps {
  item: KeyQuestionFeedItem;
  onClose: () => void;
}

const KeyQuestionDetailsPanel = ({
  item,
  onClose,
}: KeyQuestionDetailsPanelProps) => {
  const {
    anchorElement: menuAnchorEl,
    onClick: onClickMenu,
    onClose: onCloseMenu,
    open: menuOpen,
  } = useAnchorElement();

  return (
    <Panel>
      <DetailsPanelHeader item={item} onClose={onClose} />
      <DetailsPanelContent spacing={1}>
        <Typography variant="bodySecondaryReg">
          <Bold>Question:</Bold> {item.text}
        </Typography>
        {item.videoClip && (
          <ContextAccordion defaultExpanded>
            <DetailsPanelVideoClip
              entityId={item.entityId}
              session={item.session}
              videoClip={item.videoClip}
            />
          </ContextAccordion>
        )}
      </DetailsPanelContent>
      <DetailsPanelFooter>
        <ActionsMenuButton onClick={onClickMenu} />
        <Menu open={menuOpen} anchorEl={menuAnchorEl} onClose={onCloseMenu}>
          <Link to={ROUTES.meetingReportById(item.session.id)}>
            <MenuItem>View Report</MenuItem>
          </Link>
        </Menu>
      </DetailsPanelFooter>
    </Panel>
  );
};

export default KeyQuestionDetailsPanel;
